import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbDatepickerModule, NgbDateParserFormatter, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-tax-financial-year-form',
  standalone: true,
  imports: [FormsModule, CommonModule, NgbDatepickerModule, NgSelectModule, NgbDropdownModule, LoaderComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './tax-financial-year-form.component.html',
  styleUrl: './tax-financial-year-form.component.scss'
})
export class TaxFinancialYearFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;
  Regimes = [{ Name: 'Old Regime', value: 'O' }, { Name: 'New Regime', value: 'N' }]
  Detail = {
    SelectType: 'U',
    ESS_TaxFinancialYearID: null as any,
    FinancialYearStart: null,
    FinancialYearEnd: null,
    OldRegimeStandardDeduction: null,
    OldRegimeRebate: null,
    NewRegimeStandardDeduction: null,
    NewRegimeRebate: null,
    EducationCessPerc: null,
    OpenDeclarationPortalDate: null as any,
    DeclarationOpenDateObj: null as any,
    LastDateForDeclarationSubmission: null as any,
    DeclarationLastDateObj: null as any,
    IsMultipleDeclarationAllowed: false,
    OpenInvestmentPortalDate: null as any,
    InvestmentOpenDateObj: null as any,
    LastDateForProofSubmission: null as any,
    InvestmentLastDateObj: null as any,
    IsMultipleProofSubmissionAllowed: false,
    PANValidationRequired: false,
    DefaultRegimeSelection: null,
    IsDraftInvestmentAllowed: false,
    IsActive: false,
  }

  constructor(
    private toast: ToastService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private incometax: IncometaxService,
    public dateFormate: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    if (this.ID > 0) {
      this.Detail.ESS_TaxFinancialYearID = this.ID;
      this.ESS_TaxFinancialYearSelect();
    }
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESS_TaxFinancialYear_InsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }

  ESS_TaxFinancialYearSelect() {
    this.isDisabled = true;
    this.incometax.ESS_TaxFinancialYearSelect({ SelectType: 'S', ESS_TaxFinancialYearID: this.Detail.ESS_TaxFinancialYearID, FinancialYearFrom: null, FinancialYearTo: null }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Detail = response.Table[0];
          this.Detail.SelectType = 'U';

          if (this.Detail.OpenDeclarationPortalDate != null && this.Detail.OpenDeclarationPortalDate != '') {
            this.Detail.DeclarationOpenDateObj = this.dateFormate.parse(new Date(response.Table[0].OpenDeclarationPortalDate).getDate().toString() + " " + this.dateFormate.month[new Date(response.Table[0].OpenDeclarationPortalDate).getMonth()] + " " + new Date(response.Table[0].OpenDeclarationPortalDate).getFullYear().toString());
          }

          if (this.Detail.LastDateForDeclarationSubmission != null && this.Detail.LastDateForDeclarationSubmission != '') {
            this.Detail.DeclarationLastDateObj = this.dateFormate.parse(new Date(response.Table[0].LastDateForDeclarationSubmission).getDate().toString() + " " + this.dateFormate.month[new Date(response.Table[0].LastDateForDeclarationSubmission).getMonth()] + " " + new Date(response.Table[0].LastDateForDeclarationSubmission).getFullYear().toString());
          }

          if (this.Detail.OpenInvestmentPortalDate != null && this.Detail.OpenInvestmentPortalDate != '') {
            this.Detail.InvestmentOpenDateObj = this.dateFormate.parse(new Date(response.Table[0].OpenInvestmentPortalDate).getDate().toString() + " " + this.dateFormate.month[new Date(response.Table[0].OpenInvestmentPortalDate).getMonth()] + " " + new Date(response.Table[0].OpenInvestmentPortalDate).getFullYear().toString());
          }

          if (this.Detail.LastDateForProofSubmission != null && this.Detail.LastDateForProofSubmission != '') {
            this.Detail.InvestmentLastDateObj = this.dateFormate.parse(new Date(response.Table[0].LastDateForProofSubmission).getDate().toString() + " " + this.dateFormate.month[new Date(response.Table[0].LastDateForProofSubmission).getMonth()] + " " + new Date(response.Table[0].LastDateForProofSubmission).getFullYear().toString());
          }
        } else { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_TaxFinancialYear_InsertUpdate() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to update?';
    if (this.Detail.IsActive) {
      modalRef.componentInstance.Message2 = 'Other then this all financial year will be deactivated';
    }

    modalRef.result.then((result) => {
      if (result) {
        this.isDisabled = true;
        if (this.Detail.DeclarationOpenDateObj != null && this.Detail.DeclarationOpenDateObj != '') {
          this.Detail.OpenDeclarationPortalDate = this.dateFormate.format(this.Detail.DeclarationOpenDateObj);
        } else {
          this.Detail.OpenDeclarationPortalDate = null;
        }

        if (this.Detail.DeclarationLastDateObj != null && this.Detail.DeclarationLastDateObj != '') {
          this.Detail.LastDateForDeclarationSubmission = this.dateFormate.format(this.Detail.DeclarationLastDateObj);
        } else {
          this.Detail.LastDateForDeclarationSubmission = null;
        }

        if (this.Detail.InvestmentOpenDateObj != null && this.Detail.InvestmentOpenDateObj != '') {
          this.Detail.OpenInvestmentPortalDate = this.dateFormate.format(this.Detail.InvestmentOpenDateObj);
        } else {
          this.Detail.OpenInvestmentPortalDate = null;
        }

        if (this.Detail.InvestmentLastDateObj != null && this.Detail.InvestmentLastDateObj != '') {
          this.Detail.LastDateForProofSubmission = this.dateFormate.format(this.Detail.InvestmentLastDateObj);
        } else {
          this.Detail.LastDateForProofSubmission = null;
        }

        this.incometax.ESS_TaxFinancialYear_InsertUpdate(this.Detail).subscribe({
          next: async (response) => {
            if (response.Error_Code == '739') {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                this.close(true);
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  close(flag = false) {
    this.activeModal.close(flag);
  }
}
